import { BOH_TRANSACTIONS_CREATE_REQUEST, BOH_TRANSACTIONS_CREATE_SUCCESS, BOH_TRANSACTIONS_CREATE_FAILURE } from './types/BalanceModificationTransactionsCreateActionsTypes';

export function postBOHTransactionsCreateRequestActionCreator(context,
  newAdjustment,
  newComments,
  newDescription,
  newEffectiveDateTime,
  newImpcCode) {
  return {
    type: BOH_TRANSACTIONS_CREATE_REQUEST,
    payload: {
      appContext: context,
      params: {
        adjustment: newAdjustment,
        comments: newComments,
        description: newDescription,
        effectiveDateTime: newEffectiveDateTime,
        impcCode: newImpcCode,
      },
    },
  };
}

export function postBOHTransactionsCreateSuccessActionCreator(data) {
  return {
    type: BOH_TRANSACTIONS_CREATE_SUCCESS,
    payload: data,
  };
}

export function postBOHTransactionsCreateFailureActionCreator(error) {
  return {
    type: BOH_TRANSACTIONS_CREATE_FAILURE,
    payload: error,
    error: true,
  };
}
